import React from 'react';
import Container from './components/Container';

const App = () => {
  return (
    <div className="App bg-teal-50">
      <Container />
    </div>
  );
};

export default App;
